<template>
  <form @submit.prevent="add">
    <!-- <form-control
      v-model="data.name"
      :errors="error ? error.errors.name : []"
      title="Name"
    /> -->
    <form-control
      v-model="data.ticker"
      :errors="error ? error.errors.ticker : []"
      title="Ticker"
    />
    <div class="form-group">
      <label>Data Provider</label>

      <multiselect
        v-model="dataProvider"
        :options="dataProviders"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.data_provider_id) ? error.errors.data_provider_id : []).length > 0
        }"
        placeholder="Type to search"
        track-by="id"
        label="name"
        @select="(val) => { data.data_provider_id = val.id }"
      />
      <form-control-error
        :errors="(error && error.errors.data_provider_id) ? error.errors.data_provider_id : []"
      />
    </div>
    <div class="form-group">
      <label>Asset Class</label>

      <multiselect
        v-model="assetClass"
        :options="assetClassses"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.asset_class_id) ? error.errors.asset_class_id : []).length > 0
        }"
        placeholder="Type to search"
        track-by="id"
        label="name"
        @select="(val) => data.asset_class_id = val.id"
      />
      <form-control-error
        :errors="(error && error.errors.asset_class_id) ? error.errors.asset_class_id : []"
      />
    </div>

    <div class="form-group mb-0">
      <label>Benchmark Ticker</label>

      <autocomplete
        ref="first"
        :allow-creation="true"
        :initial-value="data.benchmark_ticker_id"
        :initial-display="benchmark ? benchmark.ticker : null"
        :class="{ 'is-invalid': ((error && error.errors.benchmark_ticker_id) ? error.errors.benchmark_ticker_id : []).length > 0 }"
        :input-class="['form-control', { 'is-invalid': ((error && error.errors.benchmark_ticker_id) ? error.errors.benchmark_ticker_id : []).length > 0 }]"
        class="align-self-center"
        placeholder="Select a benchmark..."
        source="/tickers?filters[]=benchmark&search="
        results-property="data"
        results-display="ticker"
        @selected="selectedBenchmark"
        @clear="selectedBenchmark"
        @create="$modal.show('create-benchmark-ticker-modal')"
      />

      <form-control-error
        :errors="(error && error.errors.benchmark_ticker_id) ? error.errors.benchmark_ticker_id : []"
      />
    </div>

    <modal
      :classes="['v--modal', 'vue-dialog']"
      :pivot-y="0.3"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      name="create-benchmark-ticker-modal"
    >
      <div class="py-3 mx-4 d-flex border-bottom modal__header">
        <h2 class="m-0">
          Create Benchmark Ticker
        </h2>
        <button
          class="close ml-auto"
          @click="$modal.hide('create-benchmark-ticker-modal')"
        >
          <icon icon="close" />
        </button>
      </div>
      <div class="mt-3 px-4">
        <benchmark-ticker-form
          ref="benchmark"
          :company-id="null"
          @created="createdBenchmarkTicker"
        />
        <div class="mt-3 py-4 d-flex border-top">
          <button
            type="button"
            class="ml-auto btn btn-outline-primary"
            @click.stop="$modal.hide('create-benchmark-ticker-modal')"
          >
            <i class="sl-ban mr-1" /> Cancel
          </button>

          <button
            type="button"
            class="ml-2 btn btn-primary "
            @click.stop="$refs.benchmark.add"
          >
            <i class="sl-plus mr-1" /> Add Ticker
          </button>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import BenchmarkTickerForm from './BenchmarkTickerForm'
import TickerFormMixin from './TickerFormMixin'
import Autocomplete from '@/components/Autocomplete'

export default {
  components: {
    BenchmarkTickerForm,
    Autocomplete,
  },
  mixins: [TickerFormMixin],

  props: {
    companyId: {
      required: false,
      type: Number,
      default: null,
    },
  },

  mounted () {
    this.data.company_id = this.companyId
  },

  methods: {

    selectedBenchmark (benchmark) {
      this.benchmark = null
      this.data.benchmark_ticker_id = null
      if (benchmark) {
        if (benchmark.object) {
          benchmark = benchmark.object
        }
        this.benchmark = benchmark
        this.data.benchmark_ticker_id = benchmark.id
      }
    },

    createdBenchmarkTicker (response) {
      this.selectedBenchmark(response.data)
      this.$modal.hide('create-benchmark-ticker-modal')
    },
  },
}
</script>
